<template>
    <div>
        <el-form :inline="true" :model="searchForm">
      <el-form-item label="产品名称：">
        <el-input  v-model.trim="searchForm.name" @keyup.enter.native="getOldToNewListHandler"  clearable  ></el-input>
      </el-form-item>
        <el-form-item label="产品系列：">
                <el-select v-model="searchForm.type" clearable>
                    <el-option value="9" label="畅刻系列"></el-option>
                    <el-option value="10" label="悦刻系列"></el-option>
                </el-select>
        </el-form-item>
         <el-form-item label="产品分组："> 
                <el-select v-model="searchForm.typeGroupId" clearable>
                    <el-option v-for="item in cardStateOption" :value="item.id" :key="item.id + item.name" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
          <el-form-item label="产品状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option value="7" label="上架"></el-option>
                    <el-option value="8" label="下架"></el-option>
                </el-select>
         </el-form-item>
      <el-form-item class="btnArea">
         <el-button type="primary" class="onlyBtn" @click="getBatchOptListHandler($event)">搜索查询</el-button>
      </el-form-item>
    </el-form>
        <el-table :data="tbpg.tableData" border   >
            <el-table-column prop="name" label="产品名称"></el-table-column>
            <el-table-column label="产品图片">
　   　     <template slot-scope="scope">
　　　     　<img :src="scope.row.imgs" width="40" height="40" class="head_pic"/>
　         　</template>
           </el-table-column>
            <el-table-column prop="kunCun" label="产品库存"></el-table-column>
            <el-table-column prop="totalHistory" label="产品历史总额"></el-table-column>
            <el-table-column prop="verifyPrice" label="成本价"></el-table-column>
            <el-table-column prop="salePrice" label="销售价"></el-table-column>
            <el-table-column prop="typeGroupName" label="产品分组"></el-table-column>
            <el-table-column prop="typeName" label="产品系列"></el-table-column>
            <el-table-column prop="stateName" label="产品状态"></el-table-column>
            <el-table-column prop="remark" label="产品备注"></el-table-column>
            <el-table-column prop="createTime" label="添加时间"></el-table-column>
            <el-table-column label="操作"  width="160px" >
                <template slot-scope="scope">
                    <el-button  type="text" @click="updateListHandler(scope.row, $event)">编辑</el-button>
                    <el-button  type="text" @click="soldListHandler(scope.row, $event)">分销</el-button>
                    <el-button  type="text" @click="getOptFailListHandler(scope.row.id, $event)">流水记录</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
        
        <el-dialog :append-to-body="true"  title="列表" :visible.sync="optFailVisible" width="1000px" :close-on-click-modal="false">
            <!-- <el-button type="primary" @click="confirmExportDialogVisible = true" style="margin-bottom:10px;"> 导 出</el-button> -->
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="typeName" label="操作类型"></el-table-column>
                <el-table-column prop="mount" label="操作数据"></el-table-column>
                <el-table-column prop="total" label="历史数据"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="createTime" label="时间"></el-table-column>
            </el-table>  
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportSimFailHandler">确 定</el-button>
            </span>
        </el-dialog>
         <el-dialog  :append-to-body="true" title="新品入库" :visible.sync="isAddShop"  width="600px" :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm"  label-width="100px">
            <el-form-item label="产品分组："> 
                <el-select v-model="batchOptForm.typeGroupId" clearable>
                    <el-option v-for="item in cardStateOption" :value="item.id" :key="item.id + item.name" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="产品照片：">
                    <input  type="file" ref="file1">
                    <div v-if="!existBackImg">产品照片：</div>
                            <img v-else :src="frontImgUrl" alt="" width="150" height="150">  
                </el-form-item>
                <el-form-item label="产品名称：" prop="name">
                    <el-input v-model.trim="batchOptForm.name"></el-input>
                </el-form-item>
                <el-form-item label="成本价/元：" prop="verifyPriceRmb">
                    <el-input v-model.trim="batchOptForm.verifyPriceRmb" ></el-input>
                </el-form-item>
                <el-form-item label="销售价/元：" prop="salePriceRmb">
                    <el-input v-model.trim="batchOptForm.salePriceRmb"></el-input>
                </el-form-item>
                 <el-form-item label="库存数：" prop="kunCun">
                    <el-input v-model.trim="batchOptForm.kunCun"></el-input>
                </el-form-item>
                 <el-form-item label="备注：" prop="remark">
                    <el-input v-model.trim="batchOptForm.remark"></el-input>
                </el-form-item>
                 <el-form-item label="产品状态：">
                <el-select v-model="batchOptForm.state" clearable>
                    <el-option value="7" label="上架"></el-option>
                    <el-option value="8" label="下架"></el-option>
                </el-select>
                 </el-form-item>
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="toAddShop">确 定</el-button>
            </div>
        </el-dialog>
         <el-dialog  :append-to-body="true" title="产品编辑" :visible.sync="isUpdateShop"  width="600px"  :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm"  label-width="100px">
             <!-- <el-form-item label="产品照片：">
                    <input  type="file" ref="file1">
                    <div v-if="!existBackImg">产品照片：</div>
                            <img v-else :src="frontImgUrl" alt="" width="150" height="150">  
                </el-form-item> -->
                <el-form-item label="产品名称：" prop="name"  >
                    <el-input v-model.trim="batchOptForm.name" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="成本价/元：" prop="verifyPriceRmb">
                    <el-input v-model.trim="batchOptForm.verifyPriceRmb" disabled="disabled" ></el-input>
                </el-form-item>
                <el-form-item label="销售价/元：" prop="salePriceRmb">
                    <el-input v-model.trim="batchOptForm.salePriceRmb"></el-input>
                </el-form-item>
                 <el-form-item label="变动类型: " prop="type">
                     <p>扣减</p>
                </el-form-item>
                   <el-form-item label="变动数量：" prop="kunCun">
                    <el-input-number v-model="batchOptForm.kunCun"
                    :precision="0" :step="1" :min="0">
                  </el-input-number>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model.trim="batchOptForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="toUpdateShop">确 定</el-button>
            </div>
        </el-dialog>
         <el-dialog  :append-to-body="true" title="产品分销" :visible.sync="isSoldShop"  width="600px"  :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm"  label-width="100px">
             <!-- <el-form-item label="产品照片：">
                    <input  type="file" ref="file1">
                    <div v-if="!existBackImg">产品照片：</div>
                            <img v-else :src="frontImgUrl" alt="" width="150" height="150">  
                </el-form-item> -->
                <el-form-item label="产品名称：" prop="name"  disabled="disabled">
                    <el-input v-model.trim="batchOptForm.name" disabled="disabled"></el-input>
                </el-form-item>
                 <el-form-item label="代理商：">
                <el-select v-model="batchOptForm.nextAgentId"   filterable>
                    <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name+'（'+item.sysUserAccountName+'）'"></el-option>
                </el-select>
            </el-form-item>
                <el-form-item label="分销数量：" prop="kunCun">
                    <el-input-number v-model="batchOptForm.kunCun"
                    :precision="0" :step="1" :min="0">
                  </el-input-number>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model.trim="batchOptForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="toSoldShop">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {sysRequest} from '@/api/customizedRequest.js'
import {getBatchOptList, getBatchOptFailList, batchChgState, exportSimChangeStateFail,smokeAdd,smokeList,smokeLogList,updatesmokeList} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            isSoldShop:false,
            isAddShop:false,
             isUpdateShop:false,
            existBackImg:false,
            frontImgUrl:'',
             searchForm: {
            type: "", //产品系列
            typeGroupId: "", //产品分组
            name:'',//产品名称
            state:''
            // moveIds: [],
           },
             agentListOption: [],
            batchOptForm: {
                name:'',
                verifyPriceRmb:'',
                salePriceRmb:'',
                typeGroupId:'',
                totalHistory:'',
                kunCun:'',
                state: '',
                remark:'',
                type:2,
                amount:'',
                id:'',
                nextAgentId:''
            },
             supplierOption: [
                 {
                    code:5,
                    description:'烟杆'
                },
                 {
                    code:6,
                    description:'烟弹'
                }
            ],
            timesOption:[
            {
                    code:9,
                    description:'畅刻二代系列'
                },
                 {
                    code:10,
                    description:'悦刻五代系列'
                },
                 {
                    code:11,
                    description:'畅刻五代系列'
                }
                   
            ],
            isMonthOption: [
                {
                    code:7,
                    description:'上架'
                },
                 {
                    code:8,
                    description:'下架'
                }
            ],
            batchOptVisible: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            optFailVisible: false,
            currentId_fail: '',
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },
            confirmExportDialogVisible:false,

            changeStateRules: {
                state: [{required: true, message: '请选择变更状态', trigger: 'blur'}],
                remark: [{required: true, message: '请选择输入变更原因', trigger: 'blur'}],
            },
            currentId:'',

            cardStateOption:[],
        }
    },
    methods: {  
        toUpdateShop(){

           sysRequest('smoke/stock/update/agent', this.batchOptForm, 'post').then(res => {
                    var code = res.data.code;
                        if(code == 200){
                             this.isUpdateShop=false;
                            this.getBatchOptListHandler();
                             this.$message.success('修改成功');  
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
        },
         toSoldShop(){

           sysRequest('smoke/agent/sold', this.batchOptForm, 'post').then(res => {
               
                    var code = res.data.code;
                        if(code == 200){
                             this.getBatchOptListHandler();
                             this.isSoldShop=false;
                             this.$message.success('修改成功');  
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
        },
        soldListHandler(row, $event){
            this.batchOptForm.id=row.id;
            this.currentId=row.id;
            this.batchOptForm.name=row.name;
            this.batchOptForm.typeGroupId=row.typeGroupId;
            this.batchOptForm.kunCun=row.kunCun;
            this.batchOptForm.verifyPriceRmb=row.verifyPrice;
            this.batchOptForm.salePriceRmb=row.salePrice;
            this.isSoldShop=true;
        },
        updateListHandler(row, $event){
            this.batchOptForm.id=row.id;
            this.currentId=row.id;
            this.batchOptForm.name=row.name;
            this.batchOptForm.typeGroupId=row.typeGroupId;
            this.batchOptForm.kunCun=row.kunCun;
            this.batchOptForm.verifyPriceRmb=row.verifyPrice;
            this.batchOptForm.salePriceRmb=row.salePrice;
            this.isUpdateShop=true;
        },
        toAddShop(){
            //var data =  JSON.parse(JSON.stringify(this.auth));
            var data= new FormData();
            console.log(this.$refs.file1)
            data.append('img',this.$refs.file1.files[0]);
            data.append('name',this.batchOptForm.name);
            data.append('verifyPriceRmb',this.batchOptForm.verifyPriceRmb);
            data.append('salePriceRmb',this.batchOptForm.salePriceRmb);
            data.append('remark',this.batchOptForm.remark);
            data.append('kunCun',this.batchOptForm.kunCun);
            data.append('typeGroupId',this.batchOptForm.typeGroupId);
            data.append('state',this.batchOptForm.state);
            sysRequest('smoke/stock/add', data, 'post').then(res => {
                        var code = res.data.code;
                        if(code == 200){
                             this.$message.success('增加成功');
                           this.getBatchOptListHandler();
                             this.isAddShop=false;
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
        },
        cancel(){
            this.isSoldShop=false;
             this.isAddShop = false;
              this.isUpdateShop = false;
            this.batchOptVisible = false;
            this.$refs.batchOptForm.resetFields();
        },
        getBatchOptListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            smokeList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getOptFailListHandler(id, $event){
            this.optFailVisible = true;
            this.currentId_fail = id;
            var searchData = {id}
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchData);
            smokeLogList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if(fileList.length > 1){
                fileList.splice(0,1);
            }
            
        },

        handleSuccess(res){
            if(res.code == 200){
                this.getBatchOptListHandler();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.upload.clearFiles();
        },

        showBatchChgStateHandler(){
            this.isAddShop = true;
        },
        sureBatchChgStateHandler(){ 
            this.$refs.batchOptForm.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
            });
        },
        exportSimFailHandler(){
            let data = {"updatasId": this.currentId_fail}
            exportSimChangeStateFail(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }
                this.confirmExportDialogVisible = false;
                this.optFailVisible = false;
            })
        },
        handleSizeChange(val){
            if(this.optFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getOptFailListHandler(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getBatchOptListHandler();
            }
        },
        handleCurrentChange(val){
            if(this.optFailVisible){
                this.tbpg_fail.currentPage = val;
                this.getOptFailListHandler(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getBatchOptListHandler();
            }
        }        
    },
    created () {
        this.getBatchOptListHandler();
common.getAgentListOptionCom(this, 'agentListOption');
        common.sysRequest('smoke/type/list', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.cardStateOption = res.data.data;
            }   
        })
    }
}
</script>
<style>

</style>
